import React, { FC } from 'react'
import { Banner } from '../../../../../components/Banner/desktop'
import AdmissionInstruction from '../../AdmissionInstruction/desktop'
import { useRotationBannerAndAdmissionInstructions } from '../bll'
import { useBannerProgramTypes } from '../../../ssr/[id]/utils/useBannerProgramTypes'
import { isPaidPackage } from '../../../ssr/[id]/utils/isPaidPackage'

export const RotationBannerAndAdmissionInstructions: FC = () => {
  const {
    isSchool,
    isShowBanner,
    admissionInstruction,
    id,
    paidPackage,
    showAdmissionInstruction,
  } = useRotationBannerAndAdmissionInstructions()

  const { extraParams } = useBannerProgramTypes()

  if (showAdmissionInstruction) {
    return (
      <AdmissionInstruction
        institutionId={id}
        admissionInstruction={admissionInstruction}
      />
    )
  }

  return (
    <>
      {!isPaidPackage(paidPackage) && !isShowBanner && !isSchool && (
        <Banner
          id={2}
          spacing={{
            bottom: 'uxlarge',
          }}
          extraParams={extraParams}
        />
      )}
    </>
  )
}
